// FILE: src/components/security/MfaGate.jsx
// Fix: Manager Mode can override `user.uid` to an owner's UID.
// We must always use the signed-in Firebase Auth UID for MFA, otherwise MFA can appear "disabled".
// This keeps manager read-only access untouched.

import { useEffect } from "react";
import { auth } from "../../firebase";
import VerifyMFAModal from "./VerifyMFAModal";
import { hasSessionBypass } from "../../utils/mfa";

export default function MfaGate({ user }) {
  // Provide a shared helper that sensitive actions can call.
  // Returning false means "MFA required" and the modal is opened.
  useEffect(() => {
    window.requireMfaStepUp = async () => {
      const uid = auth.currentUser?.uid || user?.uid;
      if (!uid) return true;
      if (hasSessionBypass(uid)) return true;

      window.dispatchEvent(new CustomEvent("mfa:open", { detail: { reason: "step-up" } }));
      return false;
    };

    return () => {
      try {
        delete window.requireMfaStepUp;
      } catch {
        // ignore
      }
    };
  }, [user?.uid]);

  // Always use the signed-in auth UID (not the manager-mode view UID).
  const authUid = auth.currentUser?.uid || user?.uid || "";

  return <VerifyMFAModal authUid={authUid} />;
}
